<template>
    <div>
        <p class="title">已关联的小程序</p>
        <div class="content-container">
            <up-small-app-card class="card" v-for="(item, index) in list" :key="index" :item="item" @refresh="refresh"></up-small-app-card>
        </div>
    </div>
</template>
<script>
import UpSmallAppCard from '@/components/UpSmallAppCard.vue';
export default {
    props: {
        list: {
            type: Array,
            default() {
                return []
            }
        }
    },
    components: {
        UpSmallAppCard
    },
    data() {
        return {
            
        }
    },
    methods: {
        refresh() {
            this.$emit('refresh');
        }
    }
}
</script>
<style lang="less" scoped>
.title {
    font-size: 16px;
    color: #5C667E;
    margin-bottom: 17px;
}
.content-container {
    border: 1px solid #E0E5EC;
    background: #fff;
    padding: 20px;
    min-height: 500px;
}
.card {
    display: inline-block;
    margin-right: 10px;
    margin-bottom: 20px;
}
</style>



// WEBPACK FOOTER //
// src/page/upManage/Manage.vue